import { EquipoDisponible } from "../../../store/equiposVentaSlice";
import { EquipoVentas } from "../../../types/vendedor";
import { IntegranteDisponible } from "./IntegranteDisponible";

interface Props {
    equipo: EquipoDisponible;
    selectable?: boolean;
    equpoIndex: number;
}

export function EquipoDisponibleItem({ equipo, equpoIndex }: Props) {
    const numIntegrantes = equipo.segundoIntegrante != null ? 2 : 1;

    return (
        <div className="h-s[50px] border border-slate-200 bg-slate-100 rounded px-2 py-[6px]">
            <p className="font-semibold text-[17px]">{equipo.identificador} integrantes disponibles: {numIntegrantes}</p>

            <div className="flex flex-col gap-y-1 my-1">
                <IntegranteDisponible
                    equipoIndex={equpoIndex}
                    integrante={equipo.primerIntegrante}/>

                {equipo.segundoIntegrante != null && (
                <IntegranteDisponible 
                    equipoIndex={equpoIndex}
                    integrante={equipo.segundoIntegrante}/>
                )}
            </div>
        </div>
    )
}
